import mixpanel from 'mixpanel-browser';
import { IS_PROD } from 'constants/isProd';

export function useMixpanel() {
  const trackEvent = (event, props) => {
    if (IS_PROD) {
      mixpanel.track(event, props);
    }
  };

  const identifyUser = (userId, userProps) => {
    if (IS_PROD) {
      mixpanel.identify(userId);
      mixpanel.people.set_once(userProps);
    }
  };

  return { trackEvent, identifyUser };
}
